






































import { Component, Vue, Mixins } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import Form from '@/mixins/form';

@Component
export default class PasswordSetupForm extends Mixins(Form) {
  passwordHidden: boolean = true;

  form: {
    token: string | null;
    email: string | null;
    password: string | null;
    password_confirmation: string | null;
  } = {
    token: null,
    email: null,
    password: null,
    password_confirmation: null,
  };

  rules: any = {};

  created() {
    this.form.email = this.$route.query.email as string;
    this.form.token = this.$route.query.token as string;

    this.rules = {
      ...this.rules,
      required: (field: string) => (v: string) =>
        !!v ||
        this.$t(`passwordSetupForm.validation.password-required`, { field }),
      min: (v: string) =>
        v.length >= 8 ||
        this.$t('passwordSetupForm.validation.password-min', { min: 8 }),
      sameAsPassword: (v: string) =>
        v === this.form.password ||
        this.$t('passwordSetupForm.validation.password-match'),
    };
  }

  submit() {
    if (!this.$refs.form.validate()) {
      return;
    }

    this.loading = true;

    axios
      .post(api.path('v1.password.reset'), this.form)
      .then((res) => {
        this.$toast.success('Your password has been reset.');
        this.$emit('success', this.form);
      })
      .catch((err) => {
        this.handleErrors(err.response.data.errors);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
